<script>

import User from "./summary/User.vue";
import Summary from "./summary/Summary.vue";
import Farms from "./summary/Farms.vue";

export default {
  name: "SectionSummary",
  components: {Farms, Summary, User},
  computed: {
    data() {
      return window['xive']['userData'];
    },
    user() {
      return this.data.user;
    }
  }
}
</script>

<template>
  <!--<User :user="user"/>-->
  <Summary :user-data="data" />
  <Farms :farms="data.farms"/>
</template>